export const DASHBOARD_PATH_LABELS: Record<string, string> = {
  '/': 'Home',
  '/contacts': 'Contacts',
  '/contacts/new': 'Create contact',
  '/dashboard': 'Dashboard overview',
  '/elements': 'Elements',
  '/elements/new': 'Create element',
  '/forms': 'Forms',
  '/forms/new': 'Create fundraising form',
  '/forms/new/event': 'Create event form',
  '/payments': 'Payments',
  '/payments/new': 'Create payment',
  '/payouts': 'Payouts',
  '/settings/compliance': 'Compliance settings',
  '/settings/custom-input-fields': 'Custom input settings',
  '/settings/embed': 'Embed settings',
  '/settings/emails': 'Email settings',
  '/settings/faqs': 'FAQ settings',
  '/settings/integrations': 'Integrations settings',
  '/settings/organization/account': 'Organization settings',
  '/settings/billing': 'Billing settings',
  '/settings/organization/permissions': 'Permissions settings',
  '/settings/organization/profile': 'Profile settings',
  '/settings/organization/users': 'Users settings',
  '/settings/payout-frequency': 'Payout frequency settings',
  '/settings/contact-portal': 'Contact portal settings',
  '/subscriptions': 'Subscriptions',
};

export function getDashboardPathLabel(path: string) {
  return DASHBOARD_PATH_LABELS[path] || path;
}
